import pkg from "../package.json";

export default {
  baseUrl: process.env.VUE_APP_API_URL,
  environment: process.env.VUE_APP_ENV,
  isProduction: process.env.VUE_APP_ENV === "production",
  isStaging: process.env.VUE_APP_ENV === "staging",
  isDevelopment: process.env.VUE_APP_ENV === "development",
  // Marketing version, kept in sync with iOS MARKETING_VERSION / Android versionName.
  appVersion: pkg.version,
  buildId: process.env.VUE_APP_BUILD_ID,
};
